export default __webpack_public_path__ + "static/media/NoDocumentsList.8989c6af.svg";